<template>
  <div align="Left">
    <md-card id="patients" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">group</i>
        </div>
        <h4 class="title">Patients</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="searchQuery" @keyup.enter="handleSearch" />
            </md-field>
          </div>
          <div class="md-layout md-gutter md-layout-item md-size-20" v-if="organizations.length > 2">
            <md-field class="md-sm">
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-button class="md-icon-button md-primary" @click="handleSearch">
              <md-icon>search</md-icon>
            </md-button>
          </div>
          <div class="md-layout md-gutter md-layout-item md-alignment-center-right" :class="[
            { 'md-size-40': organizations.length > 2 },
            { 'md-size-60': organizations.length <= 2 }
          ]">
            <md-button :disabled="isLoading" class="md-icon-button md-primary" @click="handleAdd">
              <md-icon>add</md-icon>
              <md-tooltip md-direction="bottom">Add new patient</md-tooltip>
            </md-button>
            <md-button :disabled="isLoading" class="md-icon-button" @click="handleRefresh">
              <md-icon>refresh</md-icon>
              <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
            </md-button>
          </div>
        </div>
      </md-card-header>

      <md-card-content style="padding-top: 0px">
        <md-table v-if="!isLoading" :value="tableData" class="table-shopping table-striped table-hover">
          <md-table-row v-if="!isLoading">
            <md-table-empty-state :md-description="`No patients found for this search value`"
              md-label="No patients found">
            </md-table-empty-state>
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Name">
              <span>{{ (item.person.firstName || "-") + " " + (item.person.lastName || "") }}</span>
            </md-table-cell>

            <md-table-cell md-label="Email">
              {{ item.person.email || "-" }}
            </md-table-cell>

            <md-table-cell md-label="Phone">{{ item.person.cellNumber || "-" }}</md-table-cell>
            <md-table-cell md-label="Status">{{ item.status || "-" }}</md-table-cell>
            <md-table-cell md-label="Actions">
              <md-button v-if="isAdmin" style="margin-right: 0.5rem" class="md-icon-button md-primary"
                @click="handleActivate(item)">
                <md-icon>{{ item.person.status == 2 ? "close" : "check" }}</md-icon>
                <md-tooltip md-direction="bottom">
                  {{ item.person.status == 2 ? "Deactivate" : "Activate" }}
                </md-tooltip>
              </md-button>
              <md-button :disabled="isLoading" class="md-icon-button" @click="handleEdit(item)">
                <md-icon>edit</md-icon>
                <md-tooltip md-direction="bottom">Edit patient</md-tooltip>
              </md-button>
              <md-button :disabled="isLoading" class="md-icon-button md-danger" style="margin-left: 0.5rem"
                @click="handleRemove(item.ID)">
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="bottom">Remove patient</md-tooltip>
              </md-button>
              <md-button class="md-icon-button" style="margin-left: 0.5rem" @click="handleChangePassword(item)">
                <md-icon>manage_accounts</md-icon>
                <md-tooltip md-direction="bottom">Change password</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex; align-items: center">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px">{{ currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startPatient }}</u></b>
                to
                <b><u>{{ endPatient }}</u></b>. Total of
                <b><u>{{ totalPatients }}</u></b>
                patients.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading || isLoadingPatient" />
    <register-patient v-if="showPatientModal" :is-edit="isEdit" :is-modal="true" @close="handleCloseModal">
    </register-patient>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import loader from "@/components/GlobeChek/loader.vue"
import RegisterPatient from "@/pages/Auth/RegisterPatient.vue"
import Swal from "sweetalert2"

export default {
  components: {
    loader,
    RegisterPatient
  },
  data() {
    return {
      isAdmin: (sessionStorage.getItem("usertype") == "Super" || sessionStorage.getItem("usertype") === 'Administrator'),
      showPatientModal: false,
      isEdit: false,
      editPatient: null,
      isLoadingPatient: false,
      tableData: [],
      searchQuery: "",
      searchedData: [],
      isLoading: false,
      offset: 0,
      limit: 50,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      currentOrganization: JSON.parse(sessionStorage.getItem("organizations")).length === 1 ? JSON.parse(sessionStorage.getItem("organizations"))[0].orgId : (localStorage.getItem("currentOrgSelectedForFilters") || "all"),
      organizations: [
        { label: 'All', value: 'all' },
        ...JSON.parse(sessionStorage.getItem('organizations')).map(i => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        }),
      ],
      defineStatus: (status) => {
        switch (status) {
          case 1:
          case "1":
            return "Pending"
          case 2:
          case "2":
            return "Active"
          case 3:
          case "3":
            return "Inactive"
          default:
            return " - "
        }
      },
    }
  },
  computed: {
    ...mapGetters(["patientsList", "totalPatients", "ptPersonal", "ptMedical", "ptHistory", "ptFamHist", "ptEditInfo"]),
    filteredPatients() {
      if (!this.tableData) return []
      return this.tableData.filter((patient) =>
        Object.values(patient).some(
          (value) => typeof value === "string" && value.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      )
    },
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.totalPatients
    },
    startPatient() {
      return this.totalPatients === 0 ? 0 : this.offset + 1
    },
    endPatient() {
      return Math.min(this.offset + this.limit, this.totalPatients)
    }
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
    }
  },
  mounted() {
    this.isLoading = true
    this.fetchPatients({ orgId: this.currentOrganization })
  },
  methods: {
    ...mapActions(["listAllPatients", "listPatientById", "removePatient", "updateUserStatus"]),
    async handleChangePassword(user) {
      this.isLoadingPatient = true
      const detailedPatient = await this.getPatientById(user.ID)
      this.$emit("openChangePasswordModal", { name: `${detailedPatient.patient.person.firstName} ${detailedPatient.patient.person.lastName}`, personId: detailedPatient.patient.person.id })
      this.isLoadingPatient = false
    },
    async handleActivate(patient) {
      if (!patient.person.status) patient.person.status = 2 // Default to active if status is null
      const payload = {
        userId: patient.person.id,
        status: patient.person.status === 2 ? 3 : 2
      }

      try {
        const res = await this.updateUserStatus({ payload, userType: "patient" })
        if (res) {
          this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
        }
      } catch (error) {
        console.error(error)
        Swal.fire({
          title: "Error!",
          text: "An error occurred while updating the patient status.",
          icon: "error"
        })
      }
    },
    async fetchPatients({ search = null, orgId = null } = {}) {
      this.isLoading = true
      try {
        const response = await this.listAllPatients({
          offset: this.offset,
          limit: this.limit,
          search: search,
          orgId: orgId != 'all' ? orgId : null
        })
        this.tableData = response.patients
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    handleSearch() {
      this.offset = 0
      localStorage.setItem('currentOrgSelectedForFilters', this.currentOrganization)
      this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    async getPatientById(patientId) {
      return await this.listPatientById({ patientId })
    },
    async handleEdit(item) {
      this.isLoadingPatient = true;
      const response = await this.getPatientById(item.ID)
      this.isLoadingPatient = false;
      const detailedPatient = response.patient

      this.ptEditInfo.ID = detailedPatient.ID
      this.ptEditInfo.personID = detailedPatient.personID
      this.ptEditInfo.insuredPersonID = detailedPatient.insuredPerson.id
      this.ptEditInfo.insuredAddressID = detailedPatient.insuredAddress.id
      this.ptEditInfo.userID = detailedPatient.userID
      this.ptEditInfo.orgId = detailedPatient.orgID

      this.ptPersonal.firstName = detailedPatient.person.firstName
      this.ptPersonal.lastName = detailedPatient.person.lastName
      this.ptPersonal.email = detailedPatient.person.email
      this.ptPersonal.DOB = detailedPatient.person.dob ? detailedPatient.person.dob.slice(0, 10) : ""
      this.ptPersonal.gender = detailedPatient.person.gender
      this.ptPersonal.height = detailedPatient.height
      this.ptPersonal.cellPhone = detailedPatient.person.cellNumber
      this.ptPersonal.allowSMS = detailedPatient.person.allowSMS

      this.ptPersonal.insurance = detailedPatient.insurance
      this.ptPersonal.insuranceId = detailedPatient.insuranceId
      this.ptPersonal.groupNumber = detailedPatient.groupNumber
      this.ptPersonal.referralNumber = detailedPatient.referralNumber
      this.ptPersonal.patientRelationshipToInsured = detailedPatient.patientRelationshipToInsured || 'Self'

      if (detailedPatient.insuredPerson) {
        this.ptPersonal.insuredFirstName = detailedPatient.insuredPerson.firstName
        this.ptPersonal.insuredLastName = detailedPatient.insuredPerson.lastName

        this.ptPersonal.insuredDOB = detailedPatient.insuredPerson.dob ? detailedPatient.insuredPerson.dob.slice(0, 10) : ""
        this.ptPersonal.insuredGender = detailedPatient.insuredPerson.gender
      }

      if (detailedPatient.address) {
        this.ptPersonal.address_L1 = detailedPatient.address.address1
        this.ptPersonal.address_L2 = detailedPatient.address.address2
        this.ptPersonal.city = detailedPatient.address.city
        this.ptPersonal.state = detailedPatient.address.state
        this.ptPersonal.zip = detailedPatient.address.zipCode
        this.ptPersonal.country = detailedPatient.address.country
        this.ptPersonal.id = detailedPatient.address.id
      }

      if (detailedPatient.insuredAddress) {
        this.ptPersonal.insuredAddress = detailedPatient.insuredAddress.address1
        this.ptPersonal.insuredCity = detailedPatient.insuredAddress.city
        this.ptPersonal.insuredState = detailedPatient.insuredAddress.state
        this.ptPersonal.insuredZip = detailedPatient.insuredAddress.zipCode
        this.ptPersonal.insuredCountry = detailedPatient.insuredAddress.country
        this.ptPersonal.insuredAddressId = detailedPatient.insuredAddress.id
      }

      this.ptMedical.chiefComplaint = detailedPatient.chiefComplaint
      this.ptMedical.issues = detailedPatient.issues

      this.ptMedical.correctiveLens = detailedPatient.wearCorrectiveLense

      this.ptMedical.glassesHistory = detailedPatient.glassesHistory
      this.ptMedical.contactsHistory = detailedPatient.contactsHistory

      if (detailedPatient.medicalHistory) {
        this.ptMedical.previousEyeSurgery = detailedPatient.medicalHistory.surgery
        this.ptMedical.historyDiabetes = detailedPatient.medicalHistory.diabetes
        this.ptMedical.historyCancer = detailedPatient.medicalHistory.cancer
        this.ptHistory.stroke = detailedPatient.medicalHistory.stroke
        this.ptHistory.migraines = detailedPatient.medicalHistory.migraines
        this.ptHistory.heartDisease = detailedPatient.medicalHistory.heart
        this.ptHistory.liverDisease = detailedPatient.medicalHistory.liver
        this.ptHistory.highCholesterol = detailedPatient.medicalHistory.cholesterol
        this.ptHistory.highBloodPressure = detailedPatient.medicalHistory.pressure
        this.ptHistory.other = detailedPatient.medicalHistory.others
      }

      if (detailedPatient.familyHistory) {
        this.ptFamHist.stroke = detailedPatient.familyHistory.stroke
        this.ptFamHist.migraines = detailedPatient.familyHistory.migraines
        this.ptFamHist.diabetes = detailedPatient.familyHistory.diabetes
        this.ptFamHist.cancer = detailedPatient.familyHistory.cancer
        this.ptFamHist.glaucoma = detailedPatient.familyHistory.glaucoma
        this.ptFamHist.alzheimers = detailedPatient.familyHistory.alzheimers
        this.ptFamHist.heartDisease = detailedPatient.familyHistory.heart
        this.ptFamHist.liverDisease = detailedPatient.familyHistory.liver
        this.ptFamHist.highCholesterol = detailedPatient.familyHistory.cholesterol
        this.ptFamHist.highBloodPressure = detailedPatient.familyHistory.pressure
        this.ptFamHist.macularDegeneration = detailedPatient.familyHistory.macDegen
        this.ptFamHist.other = detailedPatient.familyHistory.other
      }

      this.isEdit = true
      this.editPatient = item
      this.showPatientModal = true
    },
    async handleRemove(patientId) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this patient?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, delete it!"
      })

      if (result.value) {
        this.isLoading = true
        try {
          await this.removePatient({ patientId })
          this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
          Swal.fire("Deleted!", "The patient has been removed.", "success")
        } catch (error) {
          console.log(error)
          Swal.fire("Error!", "Something went wrong.", error)
        } finally {
          this.isLoading = false
        }
      }
    },
    handleAdd() {
      this.isEdit = false
      this.editPatient = null // reset editPatient
      this.showPatientModal = true
    },
    handleRefresh() {
      this.offset = 0
      this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    handleCloseModal(changedSomething) {
      this.$store.dispatch("clearPrereg")
      this.isEdit = false
      this.showPatientModal = false
      if (changedSomething) {
        this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.fetchPatients({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#referral {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: left;
}

.table-shopping {
  table>thead>tr>th {
    text-transform: uppercase;
  }

  table>thead>tr>.md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-name {
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
    }
  }

  .td-name {
    min-width: 200px;
  }

  .td-phone {
    text-align: left;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.mmodal-container {
  max-width: 70vw;
  max-height: 75vh !important;
  overflow: auto;

  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  z-index: 9999;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.pagination-container span {
  margin: 0 15px;
}
</style>
